import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import QCPointActions, { qcPointActionTypes } from '@Actions/quality/qcPointActions';
import QCPointServices from '../../services/quality/qcPointServices';

/**
 * @param action
 */
function* _createQCPoint(action) {
  try {
    yield put(QCPointActions.createQCPointLoading(true));
    const qcPoint = yield QCPointServices.createQCPoint(action.payload);
    if (qcPoint.success) {
      yield put(TrackerActions.trackAction(qcPointActionTypes.CREATE_QC_POINT.SUCCESS, qcPoint.data));
      notification.open({
        type: 'success',
        message: 'Quality Control Point successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(qcPoint?.data?.[0]);
      yield put(QCPointActions.createQCPointLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: qcPoint?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(QCPointActions.createQCPointLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(QCPointActions.createQCPointLoading(false));
    yield put(TrackerActions.trackAction(qcPointActionTypes.CREATE_QC_POINT.ERROR, error));
  }
}

/**
 *
 */
function* createQCPoint() {
  yield takeLatest(qcPointActionTypes.CREATE_QC_POINT.REQUEST, _createQCPoint);
}

/**
 * @param action
 */
function* _updateQCPoint(action) {
  try {
    yield put(QCPointActions.updateQCPointLoading(true));
    const qcPoint = yield QCPointServices.updateQCPoint(action.payload);
    if (qcPoint.success) {
      yield put(TrackerActions.trackAction(qcPointActionTypes.UPDATE_QC_POINT.SUCCESS, qcPoint.data));
      notification.open({
        type: 'success',
        message: 'Quality Control Point successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(qcPoint);
      yield put(QCPointActions.updateQCPointLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: qcPoint?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(QCPointActions.updateQCPointLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(QCPointActions.updateQCPointLoading(false));
    yield put(TrackerActions.trackAction(qcPointActionTypes.UPDATE_QC_POINT.ERROR, error));
  }
}

/**
 *
 */
function* updateQCPoint() {
  yield takeLatest(qcPointActionTypes.UPDATE_QC_POINT.REQUEST, _updateQCPoint);
}

/**
 * @param action
 */
function* _updateQCPointProduct(action) {
  try {
    yield put(QCPointActions.updateQCPointProductLoading(true));
    const qcPoint = yield QCPointServices.updateQCPointProduct(action.payload);
    if (qcPoint.success) {
      yield put(TrackerActions.trackAction(qcPointActionTypes.UPDATE_QC_POINT.SUCCESS, qcPoint.data));
      notification.open({
        type: 'success',
        message: 'Quality Control Rule successfully updated for the product',
        duration: 4,
        placement: 'top',
      });
      action.callback(qcPoint);
      yield put(QCPointActions.updateQCPointProductLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: qcPoint?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(QCPointActions.updateQCPointProductLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(QCPointActions.updateQCPointProductLoading(false));
    yield put(TrackerActions.trackAction(qcPointActionTypes.UPDATE_QC_POINT_PRODUCT.ERROR, error));
  }
}

/**
 *
 */
function* updateQCPointProduct() {
  yield takeLatest(qcPointActionTypes.UPDATE_QC_POINT_PRODUCT.REQUEST, _updateQCPointProduct);
}

/**
 * @param action
 */
function* _getQCPoints(action) {
  try {
    yield put(QCPointActions.getQCPointsLoading(true));
    const {
      tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword, defaultAssigneeId,
    } = action;
    const qcPoints = yield QCPointServices.getQCPoints(tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword, defaultAssigneeId);
    yield put(QCPointActions.getQCPointsSuccess(qcPoints));
    yield put(QCPointActions.getQCPointsLoading(false));
  } catch (error) {
    yield put(QCPointActions.getQCPointsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qcPointActionTypes.GET_QC_POINTS.ERROR, error));
  }
}

/**
 *
 */
function* getQCPoints() {
  yield takeLatest(qcPointActionTypes.GET_QC_POINTS.REQUEST, _getQCPoints);
}

/**
 * @param action
 */
function* _getQCPointById(action) {
  try {
    yield put(QCPointActions.getQCPointByIdLoading(true));
    const {
      tenantId, groupId,
    } = action;
    const selectedQCPoint = yield QCPointServices.getQCPoints(tenantId, groupId);
    yield put(QCPointActions.getQCPointByIdSuccess(selectedQCPoint?.quality_control_rules?.[0] || {}));
    yield put(QCPointActions.getQCPointByIdLoading(false));
  } catch (error) {
    yield put(QCPointActions.getQCPointByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qcPointActionTypes.GET_QC_POINT_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getQCPointById() {
  yield takeLatest(qcPointActionTypes.GET_QC_POINT_BY_ID.REQUEST, _getQCPointById);
}

/**
 * @param action
 */
function* _deleteQCPoint(action) {
  try {
    yield put(QCPointActions.deleteQCPointLoading(true));
    const qcPoint = yield QCPointServices.deleteQCPoint(action.payload);

    if (qcPoint.success) {
      notification.open({
        type: 'success',
        message: 'Quality Control Point successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: qcPoint?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(QCPointActions.deleteQCPointLoading(false));
  } catch (error) {
    yield put(QCPointActions.deleteQCPointLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qcPointActionTypes.DELETE_QC_POINT.ERROR, error));
  }
}

/**
 *
 */
function* deleteQCPoint() {
  yield takeLatest(qcPointActionTypes.DELETE_QC_POINT.REQUEST, _deleteQCPoint);
}

/**
 * @param action
 */
function* _deleteQCPointGroup(action) {
  try {
    yield put(QCPointActions.deleteQCPointGroupLoading(true));
    const qcPoint = yield QCPointServices.deleteQCPointGroup(action.payload);

    if (qcPoint.success) {
      notification.open({
        type: 'success',
        message: 'Quality Control Point Group successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: qcPoint?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(QCPointActions.deleteQCPointGroupLoading(false));
  } catch (error) {
    yield put(QCPointActions.deleteQCPointGroupLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qcPointActionTypes.DELETE_QC_POINT_GROUP.ERROR, error));
  }
}

/**
 *
 */
function* deleteQCPointGroup() {
  yield takeLatest(qcPointActionTypes.DELETE_QC_POINT_GROUP.REQUEST, _deleteQCPointGroup);
}

/**
 * @param action
 */
function* _getQCPointBySkuId(action) {
  try {
    yield put(QCPointActions.getQCPointBySkuIdLoading(true));
    const {
      tenantId, productSkuId,
    } = action;
    const qcPointsBySkuId = yield QCPointServices.getQCPoints(tenantId, null, null, productSkuId);
    yield put(QCPointActions.getQCPointBySkuIdSuccess(qcPointsBySkuId));
    yield put(QCPointActions.getQCPointBySkuIdLoading(false));
  } catch (error) {
    yield put(QCPointActions.getQCPointBySkuIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qcPointActionTypes.GET_QC_POINT_BY_SKU_ID.ERROR, error));
  }
}

/**
 *
 */
function* getQCPointBySkuId() {
  yield takeLatest(qcPointActionTypes.GET_QC_POINT_BY_SKU_ID.REQUEST, _getQCPointBySkuId);
}

// get quality check report
function* _getQCPointsReport(action) {
  try {
    yield put(QCPointActions.getQCPointsReportLoading(true));
    const { tenantId, selectedEmails, userId } = action;
    const response = yield QCPointServices.getQCPointsReport(tenantId, selectedEmails, userId);
    if (response.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: response.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) action.callback();
    yield put(QCPointActions.getQCPointsReportLoading(false));
  } catch (error) {
    yield put(QCPointActions.getQCPointsReportLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(qcPointActionTypes.DOWNLOAD_QC_POINTS.ERROR, error));
  }
}

function* getQCPointsReport() {
  yield takeLatest(qcPointActionTypes.DOWNLOAD_QC_POINTS.REQUEST, _getQCPointsReport);
}

/**
 *
 */
export default function* qcPointSaga() {
  yield all([
    createQCPoint(),
    updateQCPoint(),
    updateQCPointProduct(),
    getQCPoints(),
    getQCPointById(),
    deleteQCPoint(),
    deleteQCPointGroup(),
    getQCPointBySkuId(),
    getQCPointsReport(),
  ]);
}
